module.exports = __webpack_public_path__ + "fonts/Univers-LT-Std-67-Bold-Condensed.f445d61.otf";